import { config } from 'config';
import axios from 'axios';
import { flyweight } from 'commons/util/interfaces';
import { REST } from 'commons/rest/rest.js';

/**
 * auth.{env} endpoint
 *
 */
function AuthAPI() {
    REST.call(this, axios, config.auth_url);

    this.api.interceptors.response.use((response) => response.data.result || response.data);
}

AuthAPI.prototype = Object.create(REST.prototype);

const authAPI = flyweight(AuthAPI);

export const getAuthAPI = () => authAPI.register();

const routes = {
    refresh_user_token: () => '/user_token/cookie_refresh',
};

export const refreshUserToken = () => getAuthAPI().get(routes.refresh_user_token());

export const deleteUserToken = () => getAuthAPI().delete(routes.refresh_user_token());
